import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormView } from '@form/cer-form-view';

export class LanguageForm extends CerFormAdapter {
  override viewSetInit(viewSet: CerFormViewSet) {
    const view = new CerFormView();

    view.viewMetadata = {
      dataApiName: 'Language', text: 'Sprog',
      primaryKey: 'num', titleFields: ['num', 'name'], baseFields: ['id', 'num', 'name', 'sorting', 'history']
    };

    view.fieldMetadata = [
      { name: "nameLocal", text: "Lokalt navn" },
      { name: "active", format: 'CheckBox', text: "Aktiv", defaultValue: true, orderBy: 'Descending', orderByPriority: 1 },
      { name: "isO2", validationMaxLen: 2, text: "ISO2" },
      { name: "isO3", validationMaxLen: 3, text: "ISO3" },
    ];

    viewSet.viewAdd(view);
  }
}
